// /technology-request — where the Technology door lands (ADR-015 §9).
//
// A stub, and deliberately a text-only one. The request surface behind this
// door is unbuilt because the two questions it waits on are Nexus's to answer,
// not the portal's: whether a technology change is a priced checkout or an
// unpriced request (ADR-013 — the portal never decides pricability), and which
// receiver it lands in (Nexus's own glossary reads Case, but the portal has no
// S2S path to create one; an Opportunity via quote submit is the only creation
// surface it has).
//
// So this page captures nothing. A form whose answers had nowhere to go would
// read as working while quietly dropping the request — the door promises a
// follow-up, and the portal can only keep that promise by handing over the
// same email and phone every other dead-end handoff uses.
//
// The door does NOT mint a Quote to get here (see DOOR_ROUTE in QuoteNew.tsx):
// a quote the portal cannot submit would sit in the customer's order list as a
// draft that never resolves.

import { TechnologyHandoff } from '../components/TechnologyHandoff.js';

export function TechnologyRequest(): JSX.Element {
  return (
    <div className="card request-stub">
      <TechnologyHandoff />
    </div>
  );
}
